if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getActiveMediaTarget() {
        const explicitSlideId = this.dataset.mediaId;
        if (explicitSlideId) {
          const activeSlide = this.querySelector(`#${explicitSlideId}`);
          if (activeSlide) return activeSlide;
        }

        const openerMediaId = this.openedBy?.getAttribute('data-media-id');
        if (!openerMediaId) return null;

        return (
          this.querySelector(`#Slide-${this.id.replace('ProductModal-', '')}-${openerMediaId}`) ||
          this.querySelector(`[data-media-id="${this.id.replace('ProductModal-', '')}-${openerMediaId}"]`) ||
          this.querySelector(`[data-media-id="${openerMediaId}"]`)
        );
      }

      syncActiveThumbnail(activeMedia) {
        const mediaId = activeMedia?.id?.split('-')?.pop() || activeMedia?.dataset?.mediaId?.split('-')?.pop();
        if (!mediaId) return;

        this.querySelectorAll('.thumbnails').forEach((thumbnail) => {
          thumbnail.classList.toggle('active', thumbnail.dataset.thumbId === mediaId);
        });
      }

      showActiveMedia() {
        const activeMedia = this.getActiveMediaTarget();
        if (!activeMedia) return;

        this.querySelectorAll('.product-image-modal.active, [data-media-id].active').forEach((element) => {
          if (element !== activeMedia) element.classList.remove('active');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        const container = this.querySelector('[role="document"]');
        activeMedia.classList.add('active');
        this.syncActiveThumbnail(activeMedia);

        requestAnimationFrame(() => {
          if (container) {
            container.scrollTop = Math.max(0, activeMedia.offsetTop);
            const activeWidth = activeMedia.clientWidth || activeMedia.offsetWidth || 0;
            container.scrollLeft = Math.max(
              0,
              activeMedia.offsetLeft - (container.clientWidth - activeWidth) / 2
            );
          }
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
